import formattingFunctions from '@/components/table/formattingFunctions'

const worklistFormat = {
  childRow: data => {
    let productRows = ''
    data.products.forEach(function(element) {
      productRows += '<tr>'
      productRows += '<td>' + element.fromTimeLocalFormatted + '</td>'
      productRows += '<td>' + element.toTimeLocalFormatted + '</td>'
      productRows += '<td>' + element.productQuantity + '</td>'
      productRows +=
        '<td><div class="activity-label activity-label--small" title="' +
        element.activity.initials +
        '" style="background: ' +
        element.activity.color +
        '">' +
        element.activity.initials +
        '</div>' +
        element.activity.description +
        '</td>'
      productRows +=
        '<td>' +
        (element.productGroupName !== null ? element.productGroupName + ' - ' : '') +
        element.productName +
        '</td>'
      productRows += '<td>' + element.segment + '</td>'
      productRows += '<td>' + formattingFunctions.booleanText(element.exclusive) + '</td>'

      productRows += '</tr>'
    })
    if (data.remark !== null) {
      productRows +=
        '<tr class="tr-notes">' +
        '<td colspan="8">' +
        '<p>' +
        '<b>External Note: </b>' +
        data.remark +
        '</p>' +
        '</td>' +
        '</tr>'
    }
    if (data.internalRemark !== null) {
      productRows +=
        '<tr class="tr-notes">' +
        '<td colspan="8">' +
        '<p>' +
        '<b>Internal Note: </b>' +
        data.internalRemark +
        '</p>' +
        '</td>' +
        '</tr>'
    }

    return (
      '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;width:100%;">' +
      '<thead class="print-hide">' +
      '<tr>' +
      '<th style="min-width: 120px;">Start</th>' +
      '<th style="min-width: 120px;">End</th>' +
      '<th style="min-width: 70px;">Visitors</th>' +
      '<th style="min-width: 220px;" class="print-hide">Activity</th>' +
      '<th style="min-width: 330px;">Product</th>' +
      '<th style="min-width: 110px;" class="print-hide">Segment</th>' +
      '<th style="min-width: 100px;" class="print-hide">Exclusive</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>' +
      productRows +
      '</tbody>' +
      '</table>'
    )
  },
}

export default worklistFormat
